import InPlayer from '@inplayer-org/inplayer.js';

export const FETCH_BRANDING_REQUEST = 'FETCH_BRANDING_REQUEST';
export const FETCH_BRANDING_SUCCESS = 'FETCH_BRANDING_SUCCESS';
export const FETCH_BRANDING_FAILURE = 'FETCH_BRANDING_FAILURE';

export const getBranding = (uuid, brandingId) => {
    return async (dispatch, getState) => {
        const { branding } = getState();
        if (branding.isFetching || branding.isFetched) {
            return null;
        }

        dispatch({ type: FETCH_BRANDING_REQUEST });

        if (brandingId) {
            brandingId = brandingId;
        } else {
            brandingId = 'default';
        }

        try {
            InPlayer.Branding.getBranding(uuid, brandingId).then(data => {
                dispatch({ type: FETCH_BRANDING_SUCCESS, data });
            });
        } catch (error) {
            dispatch({ type: FETCH_BRANDING_FAILURE });
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/branding.js